import { ElementType, forwardRef, RefAttributes } from 'react';
import { Button as MuiButton, ButtonProps as MuiButtonProps } from '@mui/material';

import { Icon, IconOption } from '@components/base';

export type ButtonProps = RefAttributes<HTMLButtonElement> &
  Omit<
    MuiButtonProps,
    | 'action'
    | 'centerRipple'
    | 'classes'
    | 'disableElevation'
    | 'disableTouchRipple'
    | 'focusRipple'
    | 'focusVisibleClassName'
    | 'LinkComponent'
    | 'onFocusVisible'
    | 'TouchRippleProps'
    | 'touchRippleRef'
  > & {
    component?: ElementType;
    leftIcon?: IconOption;
    rightIcon?: IconOption;
  };

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant, children, leftIcon, rightIcon, ...rest }, ref) => (
    <MuiButton
      endIcon={rightIcon && <Icon name={rightIcon} />}
      ref={ref}
      startIcon={leftIcon && <Icon name={leftIcon} />}
      variant={variant}
      {...rest}
    >
      {children}
    </MuiButton>
  )
);

Button.displayName = 'Button';
